export default "__VITE_ASSET__DZ8n7upd__"